/* eslint-disable no-console */
import { inject, Injectable } from '@angular/core';

import { MessageRequest, MessageResponse, CoreWebsocketService } from '@senet-uiverse/websockets';

@Injectable({ providedIn: 'root' })
export class WebsocketService {
  private readonly ws = inject(CoreWebsocketService<MessageRequest | MessageResponse>);

  open(domain: Readonly<string>) {
    return this.ws.create({
      url: `wss:${domain}/ws/`,
      openObserver: {
        next: () => console.log('%c✓ Opened WS observer', 'color: #10b981; font-weight: bold'),
      },
      closeObserver: {
        next: () => console.log('%c✗ Closed WS observer', 'color: #ef4444; font-weight: bold'),
      },
      closingObserver: {
        next: () => console.log('%c⚠ Closing WS observer', 'color: #f59e0b; font-weight: bold'),
      },
    });
  }

  close() {
    this.ws.close();
  }
}
